module.exports = __webpack_public_path__ + "static/uark.a07a1b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/uark.png
// module id = 2200
// module chunks = 61762850755587